import PropTypes from 'prop-types';
import React from 'react';
import CalendarBodyLine from '../CalendarBodyLine';

/**
 * @callback onAction
 */
/**
 * Calendar table timeline
 * @param {Moment} day
 * @param {Array<Moment>} range
 * @param {Array} data
 * @param {onAction} onAction
 */
function CalendarTableBody({ day, range, data, onAction, isPermissionAvailable }) {
  if (!Array.isArray(data)) {
    return '';
  }

  if(!data.length){
    return(
        <div className='no_data_msg'>
           No data to display.
        </div> 
      )
    }
    return(
      data?.map((unit) => (
              <CalendarBodyLine unit={unit} key={unit.id} onAction={onAction} day={day} range={range} isPermissionAvailable={isPermissionAvailable}/>
            ))
    );
}

CalendarTableBody.propTypes = {
  day: PropTypes.any,
  range: PropTypes.array,
  data: PropTypes.array,
  onAction: PropTypes.func.isRequired,
  isPermissionAvailable: PropTypes.func
};

export default React.memo(CalendarTableBody);
